import { render, staticRenderFns } from "./OfertsHotelPricesBySuplement.vue?vue&type=template&id=a8e21e3c&scoped=true&"
import script from "./OfertsHotelPricesBySuplement.vue?vue&type=script&lang=js&"
export * from "./OfertsHotelPricesBySuplement.vue?vue&type=script&lang=js&"
import style0 from "./OfertsHotelPricesBySuplement.vue?vue&type=style&index=0&id=a8e21e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e21e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDatePicker,VIcon,VListItem,VListItemTitle,VMenu,VRow,VSelect,VSwitch,VTextField,VTextarea,VTooltip})
